import React, { useEffect, useState } from 'react'
import styles from './selectFromFile.jcss'
import translate from '../../core/translate'
import Icon from '../../blocks.simple/icon/icon'
import Modal from '../../blocks.simple/modal/modal'
import { colors } from '../../theme'
import { Steps } from '../../atoms/Steps/Steps-view'
import { CustomScroll } from '../../atoms/CustomScroll'
import Button from '../../blocks.simple/button/button'

export const SelectFromFileToolbarContent = ({
    selectedItems,
    notSelectedItems,
    onClearSelectFromFile,
}: {
    selectedItems: any
    notSelectedItems?: any
    onClearSelectFromFile?: () => void
}) => {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [activeTab, setActiveTab] = useState<string>('')

    const getEmptyMessage = (active: boolean) => {
        return active && <div className={styles.emptyList}>{translate('listIsEmpty')}</div>
    }

    useEffect(() => {
        setActiveTab(notSelectedItems && notSelectedItems.length ? 'notSelected' : 'selected')
    }, [notSelectedItems])

    return (
        <div>
            <div className={styles.selectedDevicesFromFile}>
                <div className={styles.selectedDevicesFromFileCondition}>
                    {translate('selected')}: <b>{selectedItems.length}</b>
                </div>
                {notSelectedItems && !!notSelectedItems.length && (
                    <div className={styles.selectedDevicesFromFileCondition}>
                        {translate('notSelected')}: <b>{notSelectedItems.length}</b>
                    </div>
                )}
                <div
                    className={styles.selectedDevicesFromFileOpenModal}
                    onClick={() => {
                        setOpenModal(true)
                    }}
                >
                    {translate('moreDetails')}
                </div>
                <Button mod={'fill'} className={styles.cancelBtn} onClick={onClearSelectFromFile}>
                    {translate('cancel')}
                </Button>
            </div>
            <Modal open={openModal} showCloseIcon={false} mod={'clear'} onClose={() => {}} transitionName={'none'}>
                <div className={styles.modal}>
                    <div className={styles.modalInner}>
                        <div
                            className={styles.close}
                            onClick={() => {
                                setOpenModal(false)
                            }}
                        >
                            <Icon type={'close'} />
                        </div>
                        <div className={styles.modalContent}>
                            <div className={styles.modalTabs}>
                                <Steps className={styles.tabs} active={activeTab} mod={'accent'}>
                                    {['notSelected', 'selected'].map((tab: string, index: number) => (
                                        <div
                                            key={`tab_${index}`}
                                            id={tab}
                                            onClick={() => {
                                                setActiveTab(tab)
                                            }}
                                        >
                                            {translate(tab)}
                                        </div>
                                    ))}
                                </Steps>
                            </div>
                            <div className={styles.modalInfo}>
                                <CustomScroll scrollType={'wide'} classNames={styles.scroll}>
                                    <table className={styles.table}>
                                        {notSelectedItems && notSelectedItems.length && activeTab === 'notSelected' ? (
                                            <>
                                                <tr className={styles.tableHeader}>
                                                    <td></td>
                                                    <td>
                                                        <b>{translate('name')}</b>
                                                    </td>
                                                </tr>
                                                {notSelectedItems.map((item: any, index: number) => {
                                                    return (
                                                        <tr key={'item_' + index}>
                                                            <td style={{ width: 50 }}>{index + 1}</td>
                                                            <td>{item}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </>
                                        ) : (
                                            getEmptyMessage(activeTab === 'notSelected')
                                        )}
                                        {selectedItems && selectedItems.length && activeTab === 'selected' ? (
                                            <>
                                                <tr className={styles.tableHeader}>
                                                    <td></td>
                                                    <td>
                                                        <b>{translate('name')}</b>
                                                    </td>
                                                </tr>
                                                {selectedItems.map((item: any, index: number) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td style={{ width: 50 }}>{index + 1}</td>
                                                            <td>{item.name}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </>
                                        ) : (
                                            getEmptyMessage(activeTab === 'selected')
                                        )}
                                    </table>
                                </CustomScroll>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
